import { render, staticRenderFns } from "./ButtonPermission.vue?vue&type=template&id=3db48b98"
import script from "./ButtonPermission.vue?vue&type=script&lang=js"
export * from "./ButtonPermission.vue?vue&type=script&lang=js"
import style0 from "./ButtonPermission.vue?vue&type=style&index=0&id=3db48b98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports